
const config = {
    VERSION: 7,
    SAKURA_MAX_ID: 5,
    SAKURA_CONTAINERS: ['S', 'M', 'L'],
    // 出現する時の外側距離
    SAKURA_MARGIN: 100,
    FRAME_DELAY: 2,
    // ステージの分割数
    AREA_DEVIDE_WIDTH: 100,
    CANVAS_WRAP: '.js-flower_wrap',
    IMAGE_PATH: '/img/flower/',
    IS_MOBILE: $('body').hasClass('isMobile'),
    // PAGE_ACTIVE: $('body#page-home').length ? 'home' : 'other',
    PAGE_ACTIVE: 'other'
};

// コンテンツ毎の設定
config.PAGE_SETTINGS = {
    other: {
        // 落下速度
        SAKURA_SPEED_Y: 4,
        // 花びらの回転
        SAKURA_ROTATE: -0.05,
        // 風の強さと方向
        WIND_WIND: -3,
        // 風によるふらぎ
        WIND_FREQUENCY: 3,
        // 花びらの数。幅100pxあたりの密度
        SAKURA_MAX: { S: 2, M: 2, L: 1 },
        // 花びらの縮尺率
        SAKURA_SCALE: { S: 0.3, M: 0.6, L: 1 },
        // 画像設定
        IMAGES: {
            sakura: [
                { name: 'sakura_1', url: `${config.IMAGE_PATH}sakura_common_1.png?${config.VERSION}` },
                { name: 'sakura_2', url: `${config.IMAGE_PATH}sakura_common_2.png?${config.VERSION}` },
                { name: 'sakura_3', url: `${config.IMAGE_PATH}sakura_common_3.png?${config.VERSION}` },
                { name: 'sakura_4', url: `${config.IMAGE_PATH}sakura_common_4.png?${config.VERSION}` },
                { name: 'sakura_5', url: `${config.IMAGE_PATH}sakura_common_5.png?${config.VERSION}` }
            ]
        }
    }
};

export default config;



// WEBPACK FOOTER //
// ./js/module/flower/config.js